import x_api_key from "../../../src/keyfile"; //create this file, add to gitignore and export that value

// Deployed defaults. Point the app at a local backend by setting the matching
// VITE_* variable in .env.local — see .env.example.
const DEPLOYED_API_URL = "https://pxhwd7ngq1.execute-api.us-east-1.amazonaws.com/dev/";
const DEPLOYED_RESUME_DOWNLOAD_API = "https://eq4oew62qi.execute-api.us-east-1.amazonaws.com/dev/";

/**
 * Callers pass relative paths (`API.get("jobs")`) which axios resolves against
 * the base URL. Without the trailing slash the last segment of the base is
 * replaced rather than extended, so an overridden URL is easy to get subtly
 * wrong.
 */
function withTrailingSlash(url: string) {
	return url.endsWith("/") ? url : `${url}/`;
}

export class StaticValue {
	getDefaultValues() {
		return {
			noResumeId: "new-resume",
			apiUrl: withTrailingSlash(import.meta.env.VITE_API_URL || DEPLOYED_API_URL),
			resumeDownloadApi: withTrailingSlash(
				import.meta.env.VITE_RESUME_DOWNLOAD_API_URL || DEPLOYED_RESUME_DOWNLOAD_API,
			),
			localStorageResumeId: "resume_id",
			// Authorization is intentionally NOT snapshotted here. It is applied
			// per-request by the request interceptors on both axios clients
			// (see apiService.js), so a prefix-less anonymous resume token is
			// never blanked by a stale snapshot taken at construction time.
			commonHeader: {
				"Content-Type": "application/json",
				"x-api-key": x_api_key,
				Accept: "application/json",
			},
		};
	}
}
